/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Joor_Orders_WaitingInputs */

const en_queue_joor_orders_waiting = /** @type {(inputs: Queue_Joor_Orders_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders from Joor waiting`)
};

/**
* | output |
* | --- |
* | "Orders from Joor waiting" |
*
* @param {Queue_Joor_Orders_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_joor_orders_waiting = /** @type {((inputs?: Queue_Joor_Orders_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Joor_Orders_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_joor_orders_waiting(inputs)
});